export type ParseQueryStringResult = Record<string, string | string[]>;

export function parseQueryString(path: string): ParseQueryStringResult {
  const queryStringIndex = path.indexOf('?');

  if (queryStringIndex === -1) {
    return {};
  }

  const queryString = path.slice(queryStringIndex + 1);
  const pairs = queryString.split('&');

  const result = {};

  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i].split('=');
    const key = decodeURIComponent(pair[0]);
    const value = decodeURIComponent(pair[1] || '');

    if (Object.prototype.hasOwnProperty.call(result, key)) {
      if (Array.isArray(result[key])) {
        result[key].push(value);
      } else {
        result[key] = [result[key], value];
      }
    } else {
      result[key] = value;
    }
  }

  return result;
}
